module.exports = __webpack_public_path__ + "static/media/redpul.a4f5cda6.md";